import { Stack, Typography } from "@mui/material";
import { MessageCircle } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const ChatEmptyState: FC = () => {
	const { t } = useResource();

	return (
		<Stack alignItems="center" justifyContent="center" gap={1.2} height="100%">
			<MessageCircle size={40} />
			<Typography variant="h3">{t(Resources.Chat.emptyTitle)}</Typography>
			<Typography variant="body2" textAlign="center">
				{t(Resources.Chat.emptyDescription)}
			</Typography>
		</Stack>
	);
};
